import React from "react";

export function PricingCardSkeleton() {
    return (
        <div className="relative bg-gradient-radial text-white font-urbanist rounded-2xl rounded-tr-3xl overflow-hidden shadow-xl border-[3px] border-white flex flex-col justify-between animate-pulse">

            {/* Title Badge Placeholder */}
            <div className="absolute -top-1 -right-1 w-36 h-12 bg-white/20 rounded-bl-3xl"></div>

            {/* Price Section */}
            <div className="w-full flex flex-row justify-center items-end mt-16 sm:mt-8">
                <div className="h-10 w-24 bg-white/20 rounded-md"></div>
                <div className="h-4 w-10 bg-white/10 rounded ml-2"></div>
            </div>

            <div className="h-4 w-40 bg-white/10 mt-3 mx-auto rounded"></div>

            {/* Divider */}
            <div className="border-t border-dashed border-white mx-6 my-6"></div>

            {/* Feature list */}
            <div className="px-7 space-y-4">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="flex items-start gap-3">
                        <div className="h-8 w-8 bg-white/10 rounded-full"></div>
                        <div className="h-4 w-44 bg-white/20 rounded"></div>
                    </div>
                ))}
            </div>

            {/* Button */}
            <div className="flex justify-center items-center px-10 py-10">
                <div className="w-full bg-white/20 h-12 rounded-[30px]"></div>
            </div>
        </div>
    );
}
